<app-laft-tab-stepper
  class="stepper"
  [totalSteps]="totalSteps"
  [currentStepIndex]="currentStepIndex"
></app-laft-tab-stepper>
<ng-content></ng-content>
